export default __webpack_public_path__ + "static/media/mario11.c48c1ada.jpg";